const FIREBASE_CONFIG = {
    apiKey: "AIzaSyBqoFKMq3qFkGJ9ibLqK3i7W70MIcwlTJ0",
    authDomain: "heraresult.firebaseapp.com",
    databaseURL: "https://heraresult.firebaseio.com",
    projectId: "heraresult",
    storageBucket: "heraresult.appspot.com",
    messagingSenderId: "517341653345",
    appId: "1:517341653345:web:e5cf44108f19737e0efd20",
    measurementId: "G-782FTRWML2"

};

export {FIREBASE_CONFIG}